function CV() {
  return (
    <main>
      <h1>CV</h1>
      <nav className="pageContent">
        <h2>Content</h2>
        <ul>
          <li>
            <a href="#intro">Introduction</a>
          </li>
          <li>
            <a href="#education">Education</a>
          </li>
          <li>
            <a href="#work">Work Experience</a>
          </li>
          <li>
            <a href="#skills">Skills</a>
          </li>
          <li>
            <a href="#interests">Interests</a>
          </li>
        </ul>
      </nav>
      <section id="intro">
        <h2>Intoduction</h2>
        <p>
          I am an enthusiastic and motivated Physics graduate. I have strong
          problem-solving and creative skills and enjoy learning about how the
          world around us works. I am willing to learn and develop new skills.
        </p>
      </section>
      <section id="education">
        <h2>Education</h2>
        <div className="experience">
          <h4 className="experienceTitle">
            BSc (Hons) Physics with Astrophysics | University of Bath
          </h4>
          <h4 className="experienceDate">
            <time dateTime="2019-09">09/2019</time>-
            <time dateTime="2022-07">07/2022</time>
          </h4>
          <p className="experienceInfo">
            First-year unit grade: Overall average First Class Honours
            <br />
            Second-year unit grade: Overall average Second Class Honours (2:1){" "}
            <br />
            Degree grade: Overall average Second Class Honours (2:2).
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">
            WJEC A level | Ysgol Dyffryn Conwy
          </h4>
          <h4 className="experienceDate">
            <time dateTime="2015-09">09/2015</time>-
            <time dateTime="2017-06">06/2017</time>
          </h4>
          <p className="experienceInfo">
            A-level: A in Physics and Mathematics and B in Biology and Welsh
            Baccalaureate. <br />
            AS: D in Chemistry.
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">WJEC GCSE | Ysgol y Moelwyn</h4>
          <h4 className="experienceDate">
            <time dateTime="2017-09">09/2017</time>-
            <time dateTime="2019-06">06/2019</time>
          </h4>
          <p className="experienceInfo">
            5A*, 4A and 2B with A* in Mathematics and Science, A in Welsh and B
            in English.
          </p>
        </div>
      </section>
      <section id="work">
        <h2>Work Experience</h2>
        <div className="experience">
          <h4 className="experienceTitle">
            Demonstrating | University of Bath
          </h4>
          <h4 className="experienceDate">
            <time dateTime="2021-09">09/2021</time>-
            <time dateTime="2021-12">12/2021</time>
          </h4>
          <p className="experienceInfo">
            Working in the second-year laboratory sessions helping to teach and
            guide students through the scripts I had helped develop. This model
            of teaching was taken up after I noticed that there was a shortage
            of PhD students to demonstrate and suggested that final year
            students could fill the gap. I am extremely proud as this model was
            such a success that it has been duplicated this year, with a second
            cohort are being invited to participate.
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">
            Summer Placement | University of Bath
          </h4>
          <h4 className="experienceDate">
            <time dateTime="2021-08">08/2021</time> - 4 weeks
          </h4>
          <p className="experienceInfo">
            My lab partner and I helped develop scripts and code to integrate
            Arduinos into the second-year electronics lab sessions, since the
            students were yet to learn C, we used Firmata (which in simple terms
            translates python to C and vice versa). We also had to figure how to
            include Arduinos into some of the second-year projects. I went from
            not having much experience at all with Arduinos to building circuits
            for data collection from a sensor. We also researched and gained an
            understanding of how other departments use Arduinos or how they
            would like to incorporate them into their teaching in the future.
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">
            Tourist Information Centre assistant | Snowdonia National Park
          </h4>
          <h4 className="experienceDate">
            <time dateTime="2018">2018</time>-<time dateTime="2021">2021</time>
          </h4>
          <p className="experienceInfo">
            Increased my knowledge of Snowdonia National Park. Developed
            patience and gained confidence in communicating in English as well
            as Welsh. Numeracy when handling money in the till, cashing up &
            balance till at the end of the day.
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">Green Lifestyle | Y Dref Werdd</h4>
          <h4 className="experienceDate">
            <time dateTime="2016-06">09/2021</time> - 5 days
          </h4>
          <p className="experienceInfo">
            This company raises awareness on how to live a green lifestyle.
            Helping organising an upcoming event.
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">
            Wardens and History departments | Snowdonia National Park
          </h4>
          <h4 className="experienceDate">
            <time dateTime="2015-12">12/2015</time> - 5 days
          </h4>
          <p className="experienceInfo">
            Helping in the researching into a Welsh hero and his home they were
            restoring at the time. Aiding the wardens with their routes surveys
            using a database, and inputting data into excel.
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">Veterinary | Dolgellau</h4>
          <h4 className="experienceDate">
            <time dateTime="2015-08">08/2015</time> - 3 days
          </h4>
          <p className="experienceInfo">
            I had a range of experiences from pinning a foal down whilst it had
            its jabs, observing as the vets helped a cow give birth,
            introduction into how to use ultrasound equipment to measuring the
            valves of the heart.
          </p>
        </div>
        <div className="experience">
          <h4 className="experienceTitle">Bar | CellB</h4>
          <h4 className="experienceDate">
            <time dateTime="2014">2014</time>-<time dateTime="2018">2018</time>
          </h4>
          <p className="experienceInfo">
            I worked my way from a pot wash, waitressing to serving at the bar.
          </p>
        </div>
      </section>
      <section id="skills">
        <h2>Skills</h2>
        <table>
          <thead>
            <tr>
              <th scope="col">Skill</th>
              <th scope="col">Experience</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Python (coding)</td>
              <td>
                <ul>
                  <li>First year of university</li>
                  <li>
                    Summer Placement - Developed using Firmata to control an
                    Arduino
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>C (coding)</td>
              <td>
                <ul>
                  <li>Second year of university</li>
                  <li>Summer Placement - developed in the Arduino IDE</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>MATLAB (coding)</td>
              <td>
                <ul>
                  <li>Online course ‘MATLAB fundamentals’</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Microsoft office</td>
              <td>
                <ul>
                  <li>Secondary school</li>
                  <li>University</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Driving license</td>
              <td>
                <ul>
                  <li>Passed my test in March 2018</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Communication</td>
              <td>
                <ul>
                  <li>
                    Summer placement – talking to lectures about how their
                    departments use Arduinos or would want to incorporate
                    Arduinos in the future
                  </li>
                  <li>
                    Experiments – communicating with my team to see if we were
                    all on track
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Problem Solving</td>
              <td>
                <ul>
                  <li>
                    Summer placement – which best components to use and how to
                    build a circuit to collect data
                  </li>
                  <li>
                    Experiments – figure out how to complete our brief with data
                    collected
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Time management</td>
              <td>
                <ul>
                  <li>
                    Summer Placement – we had a month to finish all the tasks
                    given to us, and a free range so time management was key
                  </li>
                  <li>Experiments – we had a semester to finish the project</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Teamwork</td>
              <td>
                <ul>
                  <li>Summer Placement - working with a partner</li>
                  <li>
                    Experiments - working with a team in the laboratory sessions
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Flexible</td>
              <td>
                <ul>
                  <li>
                    Summer placement – sometimes the manager would think of new
                    ideas for us to try out so we would have to change direction
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Concise</td>
              <td>
                <ul>
                  <li>
                    Demonstrating - Simplifying and concise explanation for
                    students
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Presentation and organisation</td>
              <td>
                <ul>
                  <li>
                    Summer placement – writing a summary and conclusion for all
                    the discoveries we had made
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Leadership</td>
              <td>
                <ul>
                  <li>Experiments - Project managing a team</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <section id="interests">
        <h2>Interests</h2>
        <p>
          At university, I joined the gym which I try to attend often with my
          friends as we help motivate each other and is a good way to keep
          mentally and physically fit. I often go walking outdoors especially
          with my dog. I enjoy being creative and innovative and express it in
          my art. I also hold an UK driving licence.
        </p>
      </section>
    </main>
  );
}

export default CV;
